"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.descripitonTranslations = {
    "en": {
        reportFor: "Report for {0}",
        print: "Print",
        exportLabel: "Export",
        from: " from ",
        to: " to",
        forToday: "for Today",
        exportToCsv: "Export to .CSV",
    },
    "de": {
        reportFor: "Bericht für {0}",
        print: "Ausdrucken",
        exportLabel: "Exportieren",
        exportToCsv: "Nach .CSV exportieren",
        from: "von",
        to: "zu",
        forToday: "für heute",
    },
    "nl": {
        reportFor: "Rapport {0}",
        print: "Printen",
        exportLabel: "Exporteren",
        exportToCsv: "Exporteren naar .CSV",
        from: "van",
        to: "aan",
        forToday: "- vandaag",
    },
    "it": {
        reportFor: "Statitsiche per {0}",
        print: "Stampa",
        exportLabel: "Esporta",
        exportToCsv: "Esporta in .CSV",
        from: "da",
        to: "da",
        forToday: "(oggi)",
    },
    "fr": {
        reportFor: "Rapport pour {0}",
        print: "Imprimer",
        exportLabel: "Exporter",
        exportToCsv: "Exporter au format .CSV",
        from: "depuis",
        to: "vers",
        forToday: "pour aujourd'hui",
    },
    "es": {
        reportFor: "Informe para {0}",
        print: "Imprimir",
        exportLabel: "Exportar",
        exportToCsv: "Exportar en archivo de formato .CSV",
        from: "de",
        to: "a",
        forToday: "para el Día de hoy",
    },
    "ja": {
        reportFor: "{0}報告書対象",
        print: "印刷",
        exportLabel: "エクスポート",
        exportToCsv: ".CSVへエクスポート",
        from: "開始日",
        to: "宛先",
        forToday: "本日分",
    },
    "en-GB": {
        reportFor: "Report for {0}",
        print: "Print",
        exportLabel: "Export",
        exportToCsv: "Export to .CSV",
        from: "from",
        to: "to",
        forToday: "for Today",
    },
    "ru": {
        reportFor: "Отчет о {0}",
        print: "Печать",
        exportLabel: "Экспорт",
        from: " c ",
        to: " по",
        forToday: "за Сегодня",
        exportToCsv: "Экспортировать в .CSV",
    },
};
